/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LocationByAddressInput = {
  readonly address1?: string | null | undefined;
  readonly address2?: string | null | undefined;
  /** id for an address present in the current session. */
  readonly addressId?: string | number | null | undefined;
  readonly city?: string | null | undefined;
  /** google places id used for delivery locations search */
  readonly googlePlaceId?: string | null | undefined;
  readonly lat?: number | null | undefined;
  readonly lon?: number | null | undefined;
  readonly state?: string | null | undefined;
  readonly useCartRestaurant?: boolean | null | undefined;
  readonly zipcode?: number | null | undefined;
};

export type ReorderRestaurantDataQueryVariables = Exact<{
  id: string | number;
}>;

export type ReorderRestaurantDataQuery = {
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly isOutpost: boolean;
    readonly deliveryFee: number;
  } | null;
};

export type ReorderDeliveryRestaurantDataQueryVariables = Exact<{
  input: Types.LocationByAddressInput;
}>;

export type ReorderDeliveryRestaurantDataQuery = {
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly slug: string;
          readonly name: string;
          readonly isOutpost: boolean;
          readonly deliveryFee: number;
          readonly sanitaryGradeDisplayText: string | null;
          readonly sanitaryGradeUrl: string | null;
        };
        readonly vendor: { readonly name: string; readonly restaurantId: string };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type ReorderDeliveryAddressDataQueryVariables = Exact<{
  addressId: string | number;
}>;

export type ReorderDeliveryAddressDataQuery = {
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly name: string | null;
  } | null;
};

export const ReorderRestaurantDataDocument = gql`
  query ReorderRestaurantData($id: ID!) {
    restaurant(id: $id) {
      id
      __typename
      slug
      name
      isOutpost
      deliveryFee
    }
  }
`;

export function useReorderRestaurantDataQuery(
  options: Omit<Urql.UseQueryArgs<ReorderRestaurantDataQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ReorderRestaurantDataQuery, ReorderRestaurantDataQueryVariables>({
    query: ReorderRestaurantDataDocument,
    ...options,
  });
}
export const ReorderDeliveryRestaurantDataDocument = gql`
  query ReorderDeliveryRestaurantData($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          id
          __typename
          slug
          name
          isOutpost
          deliveryFee
          sanitaryGradeDisplayText
          sanitaryGradeUrl
        }
        vendor {
          name
          restaurantId
        }
      }
    }
  }
`;

export function useReorderDeliveryRestaurantDataQuery(
  options: Omit<Urql.UseQueryArgs<ReorderDeliveryRestaurantDataQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    ReorderDeliveryRestaurantDataQuery,
    ReorderDeliveryRestaurantDataQueryVariables
  >({ query: ReorderDeliveryRestaurantDataDocument, ...options });
}
export const ReorderDeliveryAddressDataDocument = gql`
  query ReorderDeliveryAddressData($addressId: ID!) {
    address(addressId: $addressId) {
      id
      __typename
      name
    }
  }
`;

export function useReorderDeliveryAddressDataQuery(
  options: Omit<Urql.UseQueryArgs<ReorderDeliveryAddressDataQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ReorderDeliveryAddressDataQuery, ReorderDeliveryAddressDataQueryVariables>({
    query: ReorderDeliveryAddressDataDocument,
    ...options,
  });
}
